module.exports = {
          srcSet: __webpack_public_path__ + "images/1900-b158dc8bc7e859e80ab61e9df193d41a-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1900-3f4fbf6eaacfa24beedde076d3622686-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1900-b158dc8bc7e859e80ab61e9df193d41a-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1900-3f4fbf6eaacfa24beedde076d3622686-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1900-b158dc8bc7e859e80ab61e9df193d41a-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1900-b158dc8bc7e859e80ab61e9df193d41a-320.jpg"},
          
          width: 320,
          height: 251
        }